"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const _excluded = ["href", "redirect", "onClick", "onClicked", "target", "urlArgs", "data-eid", "data-tcc-ignore"];
/**
 * Prepares dataLayer payload
 *
 * @param {String} eid - eid
 * @returns {Object} - Confguration for the dataLayer
 */
function dataLayerConfig(eid) {
  var _window, _window$ux, _window$ux$eldorado, _window$ux$eldorado$d;
  const data = ((_window = window) === null || _window === void 0 ? void 0 : (_window$ux = _window.ux) === null || _window$ux === void 0 ? void 0 : (_window$ux$eldorado = _window$ux.eldorado) === null || _window$ux$eldorado === void 0 ? void 0 : (_window$ux$eldorado$d = _window$ux$eldorado.data) === null || _window$ux$eldorado$d === void 0 ? void 0 : _window$ux$eldorado$d.props) || {};
  const {
    location
  } = window;
  const customProperties = {
    app: data.app,
    hostname: location.hostname,
    path: location.path,
    query: location.search,
    market: data.market,
    lang: data.languageName,
    country: data.countryName,
    currency: data.currency,
    split: data.split
  };
  return {
    schema: 'add_event',
    version: 'v2',
    data: {
      eid,
      type: 'click',
      custom_properties: customProperties
    }
  };
}
const Link = /*#__PURE__*/_react.default.forwardRef(function Link(props, ref) {
  const {
      href = '',
      redirect,
      onClick,
      onClicked = Function.prototype,
      target = '_self',
      urlArgs = {},
      'data-eid': eid,
      'data-tcc-ignore': tccIgnore
    } = props,
    rest = (0, _objectWithoutProperties2.default)(props, _excluded);

  // !! IMPORTANT !! Traffic2 (specifically tcc.combined.**.min.js)
  // will intercept ANY click on ANY element with an `href` attribute. Since we wish
  // to set our own `window.location` we must set `data-tcc-ignore` so that
  // no click listener is added by Traffic2.
  const shouldRedirect = tccIgnore || !href.startsWith('tel:') && Boolean(redirect || Object.keys(urlArgs).length);
  const onRedirect = _react.default.useCallback(function direct(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    onClicked(ev);
    if (eid && window._expDataLayer) {
      window._expDataLayer.push(dataLayerConfig(eid));
    }
    let url = href;
    try {
      const base = new window.URL(redirect || href);
      Object.entries(urlArgs).forEach(args => base.searchParams.set(...args));
      url = base.href;
    } catch (err) {
      // fail silently
    }
    window.open(url, ev.metaKey || ev.ctrlKey ? '_blank' : target);
    return false;
  }, [eid, onClicked, redirect, href, target, urlArgs]);
  return (
    /*#__PURE__*/
    // In this forwardRef component the a11y rule jsx-a11y/anchor-has-content can be ignored
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.default.createElement("a", (0, _extends2.default)({
      href: href,
      target: target,
      ref: ref,
      onClick: onClick || shouldRedirect && (ev => onRedirect(ev)) || onClicked,
      "data-eid": eid,
      "data-tcc-ignore": shouldRedirect || null
    }, rest))
  );
});

/**
 * PropTypes for Link. Most map directly to HTML attributes on the `<a>`.
 * @type {Object}
 * @public
 */

Link.propTypes = {
  /** Eid to be used on link click events */
  'data-eid': _propTypes.default.string,
  /** Restricts click listener that is added by Traffic2. */
  'data-tcc-ignore': _propTypes.default.bool,
  /** Content for the link */
  'children': _propTypes.default.node.isRequired,
  /** Link Destination */
  'href': _propTypes.default.string.isRequired,
  /** A function to call after a link gets clicked */
  'onClick': _propTypes.default.func,
  /** A function to call after a link gets clicked when a redirect is applied and onClick is undefined */
  'onClicked': _propTypes.default.func,
  /** Redirect URl when you want something different than the href */
  'redirect': _propTypes.default.string,
  /** Additional info for link component  */
  'urlArgs': _propTypes.default.object,
  /** Target for the link */
  'target': _propTypes.default.string
};
var _default = Link;
exports.default = _default;